import { ActionGroupStatus } from "./action-group.interface";

export type ActionResponse = {
	statusCode: number;
	body: IAction[];
};

export interface IActionGroupRef {
	_id: string;
	name: string;
	icon?: string;
	status?: ActionGroupStatus;
}

export interface IAction {
	_id: string;
	code: string;
	name: string;
	description: string;
	type: string;
	link: string;
	order: number;
	subActions: IAction[];
	/** Populated ActionGroup or raw ObjectId string (SIMS-8592). */
	groupId?: string | IActionGroupRef;
	/** Navigation icon for MENU_OPTION actions (SIMS-8592). */
	icon?: string;
}

export const resolveActionGroupId = (
	groupId: IAction["groupId"],
): string | undefined => {
	if (!groupId) return undefined;
	if (typeof groupId === "string") return groupId;
	return groupId._id;
};

export const resolveActionGroupName = (
	groupId: IAction["groupId"],
): string | undefined => {
	if (!groupId || typeof groupId === "string") return undefined;
	return groupId.name;
};
